import React, {useEffect} from 'react'
import Page from '../components/Page'
import Typography from '../components/Typography'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Spinner, Button, Card, CardBody, CardHeader, Col, Label, Row, Form, FormFeedback, FormGroup, FormText, Input, Table, Nav, NavItem, NavLink, TabContent, TabPane, Modal, ModalBody, ModalFooter, ModalHeader, ButtonGroup } from 'reactstrap'
import { MdEdit, MdFormatListBulleted, MdFlag, MdLanguage, MdHome, MdAdd, MdCameraAlt, MdDone, MdClear, MdStore, MdFilterList, MdCreate, MdDelete } from 'react-icons/md'
import { Redirect } from 'react-router'
import StorageService from '../services/StorageService'
import axios from '../utils/posAxios'
import PosProductModal from '../components/PosProductModal'
import PosProductForm from '../components/PosProductForm'
import PosPriceModeForm from '../components/PosPriceModeForm'
import { MDBDataTableV5, MDBIcon } from 'mdbreact'
import PosProductConditionForm from '../components/PosProductConditionForm'
import moment from 'moment-timezone'
import { backgroundColor } from '@syncfusion/ej2-richtexteditor/src/rich-text-editor/models/items'

const tbcolumn = [
  {
    label: 'Order ID',
    field: 'order_id',
    sort: 'asc',
  },
  {
    label: 'Quantity',
    field: 'qty',
    sort: 'asc',
  },
  {
    label: 'Price',
    field: 'price',
    sort: 'asc',
  },
  {
    label: 'Update Date',
    field: 'updated_dt',
    sort: 'asc',
  },
]

class PosStoreDetailPage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      modal: false,
      badgeModal: false,
      priceModModal: false,
      conditionModal: false,
      formModal: false,
      confirmModal: false,
      redirect: false,
      isLoading: true,
      deleteType: '',
      store_id: this.props.match.params.id,
      product_id: this.props.match.params.productid,
      product_no: '',
      name: '',
      chn_name: '',
      image: '',
      imagePreviewUrl: '',
      category: '',
      parent: '',
      product_type: '',
      supplier: '',
      qty_data: [{ unit: '', qty: '0' }],
      price_data: [{ unit: '', price: '0.00' }],
      product_data: '',
      eng_description: '',
      chn_description: '',
      container: '',
      alerts: { stock_warning: { warn: '0', alert: '0', no_order: '0' } },
      tags: '',
      price_mod: [],
      ignore_stock: '',
      nett_price: 0,
      inventory_log: [],
      order_log: [],
      product_condition: [],
      show_badge: '',
      badge: '',
      follow_price: 0,
      weight: null,
      set: null,
      combo: null,
      contract: null,
      quotationqty: '',
      orderqty: '',
      preparationqty: '',
      material:[]
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    Promise.all([
      this.getStoreProductDetail(),
      this.getInventoryLog(),
      this.getOrderLog()
    ])
    .then(()=> {
      //this.setState({isLoading:false});
    })
    .catch(error => {
      console.error(error);
      this.setState({ isLoading: false });
    });
  }

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit: id != undefined || (id != null && action == 'EDIT') ? true : false,
      selectedId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    })
  }

  togglePriceMode = (action, id) => () => {
    return this.setState({
      priceModModal: !this.state.priceModModal,
      isEdit: id != undefined || (id != null && action == 'EDIT') ? true : false,
      selectedId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    })
  }

  toggleProductCondition = (action, id) => () => {
    return this.setState({
      conditionModal: !this.state.conditionModal,
      isEdit: id != undefined || (id != null && action == 'EDIT') ? true : false,
      selectedId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    })
  }

  toggleForm = (action, id) => () => {
    return this.setState({
      formModal: !this.state.formModal,
      isEdit: action == 'EDIT' ? true : false,
      isStock: action == 'STOCK' ? true : false,
      selectedId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    })
  }

  toggleConfirmModal = (name, id, type) => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
      selectedData: name,
      selectedId: id,
      deleteType: type,
    })
  }

  toggleBadgeConfig = () => () => {
    return this.setState({
      badgeModal: !this.state.badgeModal,
      edit_show_badge: this.state.show_badge,
      edit_badge: this.state.badge,
    })
  }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      modal: false,
      formModal: false,
      priceModModal: false,
      conditionModal: false,
      badgeModal: false,
    })

    if (reload) {
      window.location.reload()
    } else {
      this.getStoreProductDetail()
      this.getInventoryLog()
    }
  }

  checkHandler = e => {
    let { name } = e.target
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.props.match.params.id,
      product_id: this.props.match.params.productid,
      ignorestock: !this.state[name] ? '1' : '0',
      update_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/store/inventory/ignorestock', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Product updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.getStoreProductDetail()
        this.getInventoryLog()
      })
      .catch(error => {
        console.error(error)
        alert(error)
        if (error === 'Unauthorised') {
          this.setState({ redirect: true })
        }
      })
  }

  nettHandler = e => {
    let { name } = e.target
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.props.match.params.id,
      product_id: this.props.match.params.productid,
      nett_price: !this.state[name] ? '1' : '0',
      update_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/store/inventory/nettprice', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Product updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.getStoreProductDetail()
        this.getInventoryLog()
      })
      .catch(error => {
        console.error(error)
        alert(error)
        if (error === 'Unauthorised') {
          this.setState({ redirect: true })
        }
      })
  }

  showbadgeHandler = e => {
    let { name } = e.target
    this.setState({
      [name]: !this.state[name],
    })
  }

  changeHandler = e => {
    let { name, value } = e.target
    this.setState({
      [name]: value,
    })
  }

  ConfigureBadge = event => {
    event.preventDefault()

    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const selected_org = StorageService.getSession('selected_org')

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.props.match.params.id,
      product_id: this.props.match.params.productid,
      show_badge: this.state.edit_show_badge,
      badge: this.state.edit_badge,
      update_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/store/badge', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.closeModal(<MdDone />, 'Badge Updated successfully.', 'success', false)
      })
      .catch(error => {
        alert(error)
      })
  }

  getStoreProductDetail = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      store_id: this.props.match.params.id,
      product_id: this.props.match.params.productid,
    }

    axios
      .post(url + ':3002/v1/product/store/detail2', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.setState({
          isLoading: false,
          store_id: this.props.match.params.id,
          product_id: this.props.match.params.productid,
          product_no: result.data.product_no,
          name: result.data.name,
          chn_name: result.data.chn_name,
          image: result.data.image,
          category: result.data.category,
          parent_id: result.data.parent_id,
          product_type: result.data.product_type,
          price_data: JSON.parse(result.data.price_data),
          qty_data: JSON.parse(result.data.qty_data),
          product_data: result.data.product_data,
          eng_description: result.data.eng_description,
          chn_description: result.data.chn_description,
          container: result.data.container,
          // alerts: result.data.alerts
          //   ? JSON.parse(result.data.alerts)
          //   : { stock_warning: { warn: 0, alert: 0, no_order: 0 } },
          alerts: JSON.parse(result.data.alerts),
          tags: result.data.tags,
          price_mod: result.data.price_mod,
          ignore_stock: result.data.ignore_stock,
          nett_price: result.data.nett_price,
          product_condition: result.data.product_condition,
          show_badge: result.data.show_badge,
          badge: result.data.badge,
          follow_price: result.data.follow_price,
          contract: result.data.contract,
          set: result.data.set,
          combo: result.data.combo,
          weight: result.data.weight,
          supplier: result.data.supplier,
          quotationqty: result.data.quotationqty,
          orderqty: result.data.orderqty,
          preparationqty: result.data.preparationqty,
          material:result.data.material
        })
      })
      .catch(error => {
        console.error(error)
        alert(error)
        if (error === 'Unauthorised') {
          this.setState({ redirect: true })
        }
      })
  }

  getInventoryLog = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.props.match.params.id,
      product_id: this.props.match.params.productid,
      limit: 100,
      update_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/store/inventory/log', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.setState({
          inventory_log: result.data,
        })
      })
      .catch(error => {
        alert(error)
        if (error === 'Unauthorised') {
          this.setState({ redirect: true })
        }
      })
  }

  getOrderLog = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.props.match.params.id,
      product_id: this.props.match.params.productid,
      limit: 100,
      update_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/store/inventory/order', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        for (let i of result.data) {
          if (i.updated_dt) {
            i.updated_dt = moment(i.updated_dt).tz('Asia/Singapore').format('YYYY-MM-DD HH:mm:ss')
          }
        }
        this.setState({
          order_log: result.data,
        })
      })
      .catch(error => {
        alert(error)
        if (error === 'Unauthorised') {
          this.setState({ redirect: true })
        }
      })
  }

  delete = () => {
    if (this.state.deleteType === 'PriceMod') {
      this.deletePriceMod()
    } else if (this.state.deleteType === 'ProductCondition') {
      this.deleteProductCondition()
    } else {
      this.deleteProduct()
    }
  }

  deleteProduct = () => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.props.match.params.id,
      product_id: this.props.match.params.productid,
      remove_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/store/remove', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Product deleted successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ confirmModal: false })
        setTimeout(() => {
          this.props.history.push('/posstore/' + this.props.match.params.id)
        }, 1000)
      })
      .catch(error => {
        alert(error)
        if (error === 'Unauthorised') {
          this.setState({ redirect: true })
        }
      })
  }

  deletePriceMod = () => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      price_id: this.state.selectedId,
      remove_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/store/detail/price_mod/delete', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Price Mode deleted successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ confirmModal: false })
        this.getStoreProductDetail()
      })
      .catch(error => {
        alert(error)
        if (error === 'Unauthorised') {
          this.setState({ redirect: true })
        }
      })
  }

  deleteProductCondition = () => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      condition_id: this.state.selectedId,
      remove_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/store/detail/condition/delete', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Product Condition deleted successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ confirmModal: false })
        this.getStoreProductDetail()
      })
      .catch(error => {
        alert(error)
        if (error === 'Unauthorised') {
          this.setState({ redirect: true })
        }
      })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }
    const data = {
      columns: tbcolumn,
      rows: this.state.order_log,
    }

    return (
      <Page
        className="PosStoreDetailPage"
        title="Stores Detail"
        breadcrumbs={[
          { name: 'Stores', active: false, path: '/posstore' },
          {
            name: 'Detail',
            active: false,
            path: '/posstore/' + this.state.store_id,
          },
          { name: 'Product Detail', active: true, path: '' },
        ]}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        {this.state.isLoading && (
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              marginTop: -16,
              marginLeft: -16,
              zIndex: 1,
            }}>
            <Spinner animation="border" variant="primary" />
          </div>
        )}
        <Row>
          <Col xl={8} lg={8} md={8}>
            <Card className="ps-card-display" style={{ height: '100%' }}>
              <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">
                Product Information
                <ButtonGroup>
                  <Button className="theme-button p-0 unity-theme-button-transparent" onClick={this.toggleBadgeConfig()}>
                    <MdEdit />
                    Configure Badge
                  </Button>
                </ButtonGroup>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    <Row form>
                      <Col lg={4}>
                        <Label>Product No.</Label>
                        <p>{this.state.product_no}</p>
                      </Col>
                      <Col lg={4}>
                        <Label>Name</Label>
                        <p>{this.state.name}</p>
                      </Col>
                      <Col lg={4}>
                        <Label>Chinese Name</Label>
                        <p>{this.state.chn_name}</p>
                      </Col>
                      <Col lg={4}>
                        <Label>Category</Label>
                        <p>{this.state.category}</p>
                      </Col>
                      <Col lg={4}>
                        <Label>Product Type</Label>
                        <p>{this.state.product_type}</p>
                      </Col>
                      <Col lg={4}>
                        <Label>Supplier</Label>
                        <p>{this.state.supplier}</p>
                      </Col>
                      {/* <Col lg={4}>
                        <Label>Tags</Label>
                        <p>{this.state.tags}</p>
                      </Col> */}
                      <Col lg={4}>
                        <Label>Show Badge</Label>
                        <p>
                          <span className={'ps-indicator ' + (this.state.show_badge == '1' ? 'on' : 'off')}>{this.state.show_badge == '1' ? 'Yes' : 'No'}</span>
                        </p>
                      </Col>
                      <Col lg={4}>
                        <Label>Badge Type</Label>
                        <p>{this.state.badge}</p>
                      </Col>
                      {/* <Col lg={4}>
                        <Label>Description (En)</Label>
                        <p>{this.state.eng_description}</p>
                      </Col>
                      <Col lg={4}>
                        <Label>Description (Chn)</Label>
                        <p>{this.state.chn_description}</p>
                      </Col> */}

                      <Col lg={12}>
                        {this.state.product_type == 'weight' && this.state.weight !== null && (
                          <Form className="AuthForm">
                            <FormGroup>
                              <Row form>
                                <Col md={12}>
                                  <FormGroup>
                                    <Label>Weight List</Label>
                                    <Table responsive hover className="ps-table tb-col-2">
                                      <thead>
                                        <tr>
                                          <th>Weight</th>
                                          <th>Fixed Price</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.weight &&
                                          this.state.weight.length > 0 &&
                                          this.state.weight.map((item, index) => {
                                            return (
                                              <tr key={index}>
                                                <td>
                                                  <p>{item.weight}</p>
                                                </td>
                                                <td>
                                                  <p>{item.fixed_price}</p>
                                                </td>
                                              </tr>
                                            )
                                          })}
                                      </tbody>
                                    </Table>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </FormGroup>
                          </Form>
                        )}

                        {this.state.product_type == 'combo' && this.state.combo !== null && (
                          <Form className="AuthForm">
                            <FormGroup>
                              <Label>Combo</Label>
                              {this.state.combo.map((item, index) => {
                                return (
                                  <Row
                                    form
                                    key={index}
                                    style={{
                                      padding: '10px',
                                      border: '1px solid #ced4da',
                                    }}>
                                    <Col md={3}>
                                      <FormGroup>
                                        <Label>Name*</Label>
                                        <p>{item.name}</p>
                                      </FormGroup>
                                    </Col>
                                    <Col md={3}>
                                      <FormGroup>
                                        <Label>Type*</Label>
                                        <p>{item.set_type}</p>
                                      </FormGroup>
                                    </Col>
                                    <Col md={3}>
                                      <FormGroup>
                                        <Label>Item Count*</Label>
                                        <p>{item.item_count}</p>
                                      </FormGroup>
                                    </Col>
                                    <Col md={3}>
                                      <FormGroup style={{ position: 'relative' }}>
                                        <Label>Required* </Label>
                                        <p>{item.required}</p>
                                      </FormGroup>
                                    </Col>
                                    <Col md={12}>
                                      <FormGroup>
                                        <Label>Product List* </Label>
                                        <Table responsive hover className="ps-table tb-col-5">
                                          <thead>
                                            <tr>
                                              <th>Product ID</th>
                                              <th>Name</th>
                                              <th>Required</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {item.product_list &&
                                              item.product_list.length > 0 &&
                                              item.product_list.map((sitem, sindex) => {
                                                return (
                                                  <tr key={sindex}>
                                                    <td>
                                                      <p>{sitem.product_id}</p>
                                                    </td>
                                                    <td>
                                                      <p>{sitem.name}</p>
                                                    </td>
                                                    <td>
                                                      <p>{sitem.required}</p>
                                                    </td>
                                                  </tr>
                                                )
                                              })}
                                          </tbody>
                                        </Table>
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                )
                              })}
                            </FormGroup>
                          </Form>
                        )}

                        {this.state.product_type === 'set' && this.state.set !== null && (
                          <Form className="AuthForm">
                            <FormGroup>
                              <Label>Set</Label>
                              <Row
                                form
                                style={{
                                  padding: '10px',
                                  border: '1px solid #ced4da',
                                }}>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label>Type*</Label>
                                    <p>{this.state.set.set_type}</p>
                                  </FormGroup>
                                </Col>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label>Item Count*</Label>
                                    <p>{this.state.set.item_count}</p>
                                  </FormGroup>
                                </Col>
                                <Col md={12}>
                                  <FormGroup>
                                    <Label>Product List* </Label>
                                    <Table responsive hover className="ps-table tb-col-3">
                                      <thead>
                                        <tr>
                                          <th>Product ID</th>
                                          <th>Name</th>
                                          <th>Required</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.set &&
                                          this.state.set.hasOwnProperty('product_list') &&
                                          JSON.parse(this.state.set.product_list).length > 0 &&
                                          JSON.parse(this.state.set.product_list).map((item, index) => {
                                            return (
                                              <tr key={index}>
                                                <td>
                                                  <p>{item.product_id}</p>
                                                </td>
                                                <td>
                                                  <p>{item.name}</p>
                                                </td>
                                                <td>
                                                  <p>{item.required}</p>
                                                </td>
                                              </tr>
                                            )
                                          })}
                                      </tbody>
                                    </Table>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </FormGroup>
                          </Form>
                        )}

                        {this.state.product_type === 'contract' && this.state.contract !== null && (
                          <Form className="AuthForm">
                            <FormGroup>
                              <Label for="contract">Contract</Label>
                              <Row
                                form
                                style={{
                                  padding: '10px',
                                  border: '1px solid #ced4da',
                                }}>
                                <Col md={4}>
                                  <FormGroup>
                                    <Label>No of Session*</Label>
                                    <p>{this.state.contract.no_sessions}</p>
                                  </FormGroup>
                                </Col>
                                <Col md={4}>
                                  <FormGroup>
                                    <Label>Duration*</Label>
                                    <p>{this.state.contract.mth_duration}</p>
                                  </FormGroup>
                                </Col>
                                <Col md={4}>
                                  <FormGroup>
                                    <Label for="no_order">Interval*</Label>
                                    <p>{this.state.contract.mth_interval}</p>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </FormGroup>
                          </Form>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {this.state.material && this.state.material.length > 0 && (
                  <Row>
                    <Col lg={12}>
                    <Label>Material</Label>
                      <Table responsive className="ps-table-2 tb-col-4" style={{width:'25vw'}}>
                        <thead>
                          <tr>
                            <th>Material Code</th>
                            <th>Qty</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.material && this.state.material.length > 0 
                          && this.state.material.map((item,index) => {
                            return (
                              <tr key={index}>
                                <td>{item.material_code}</td>
                                <td>{item.qty}</td>
                              </tr>
                            )
                          })} 
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col lg={12}>
                    <Label for='productTags'>Tags</Label>
                    <Input name='productTags' type='textarea' rows={5} value={this.state.tags} style={{backgroundColor:'white', boxShadow:'none', outline:'none', border:'none', resize:'none', padding:'0px'}} readOnly></Input>
                    {/* <p>{this.state.tags}</p> */}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col xl={4} lg={4} md={4}>
            <Card className="ps-card-display unity-product-panel">
              <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">
                <ButtonGroup className="is-centered">
                  <Button className="theme-button p-0 unity-theme-button-transparent" onClick={this.toggleForm('EDIT', this.state.product_id)}>
                    <MdEdit />
                    Edit
                  </Button>
                  <Button className="theme-button p-0 unity-theme-button-transparent" onClick={this.toggleForm('STOCK', this.state.product_id)}>
                    <MdStore />
                    Stock
                  </Button>
                  <Button className="theme-button p-0 unity-theme-button-transparent" onClick={this.toggleConfirmModal(this.state.name)}>
                    <MdDelete />
                    Delete
                  </Button>
                </ButtonGroup>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    <FormGroup row>
                      {/* <Label md={5}>Quantity</Label>
                      <Col md={7}>
                        <Input value={this.state.qty_data[0].qty} readOnly />
                      </Col> */}
                      <Table responsive className="ps-table-2 tb-col-4">
                        <thead>
                          <tr>
                            <th>Quantity</th>
                            <th>Quotation</th>
                            <th>Order</th>
                            <th>Preparation</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <p>{this.state.qty_data[0].qty}</p>
                            </td>
                            <td>
                              <p>{this.state.quotationqty}</p>
                            </td>
                            <td>
                              <p>{this.state.orderqty}</p>
                            </td>
                            <td>
                              <p>{this.state.preparationqty}</p>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup row>
                      <Label md={5}>Price</Label>
                      <Col md={7}>
                        <Input value={'$' + this.state.price_data[0].price} readOnly />
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup row>
                      <Label md={5}>Follow Price</Label>
                      <Col md={7}>
                        <div className="form-control">
                          <span className={'ps-indicator ' + (this.state.follow_price == '1' ? 'on' : 'off')}>{this.state.follow_price == '1' ? 'Yes' : 'No'}</span>
                        </div>
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup row>
                      <Label md={5}>Stock Alert</Label>
                      <Col md={7}>
                        <Input value={this.state.alerts.stock_warning.alert} readOnly />
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup row>
                      <Label md={5}>Stock Warning</Label>
                      <Col md={7}>
                        <Input value={this.state.alerts.stock_warning.warn} readOnly />
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup row>
                      <Label md={5}>No Order</Label>
                      <Col md={7}>
                        <Input value={this.state.alerts.stock_warning.no_order} readOnly />
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input type="checkbox" name="ignore_stock" checked={this.state.ignore_stock} onChange={this.checkHandler} />
                        Ignore Stock
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input type="checkbox" name="nett_price" checked={this.state.nett_price} onChange={this.nettHandler} />
                        Nett Price
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display main">
              <CardBody>
                <Row>
                  <Col>
                    <div className="text-left">
                      <Typography className="h5">Price Modification</Typography>
                    </div>
                  </Col>
                  <Col>
                    <div className="text-right mb-4">
                      <Button className="theme-button theme-button-primary" onClick={this.togglePriceMode('ADD', null)}>
                        Create
                      </Button>
                    </div>
                  </Col>
                </Row>
                <Table responsive hover className="ps-table tb-col-6">
                  <thead>
                    <tr>
                      <th>Price</th>
                      <th>Min Quantity</th>
                      <th>Max Quantity</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.price_mod.length < 1 && (
                      <tr>
                        <td colSpan="6">
                          <div className="ps-empty-data">
                            <div className="empty-content">
                              <MdCreate />
                              <h4>No data to show</h4>
                              <span>Click the 'Create' button to add new price mode</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}

                    {this.state.price_mod &&
                      this.state.price_mod.length > 0 &&
                      this.state.price_mod.map(item => {
                        return (
                          <tr key={item.id}>
                            <td>{JSON.parse(item.price_data)[0].price}</td>
                            <td>{item.min_qty}</td>
                            <td>{item.max_qty}</td>
                            <td>{item.start_dt}</td>
                            <td>{item.end_dt}</td>
                            <td>
                              <div className="ps-action-button">
                                <Button className="theme-button theme-button-secondary" onClick={this.togglePriceMode('EDIT', item.id)}>
                                  Edit
                                </Button>
                                <Button color="link" className="theme-button theme-button-primary-light" onClick={this.toggleConfirmModal(JSON.parse(item.price_data)[0].price, item.id, 'PriceMod')}>
                                  Delete
                                </Button>
                              </div>
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display main">
              <CardBody>
                <Row>
                  <Col>
                    <div className="text-left">
                      <Typography className="h5">Product Condition</Typography>
                    </div>
                  </Col>
                  <Col>
                    <div className="text-right mb-4">
                      <Button className="theme-button theme-button-primary" onClick={this.toggleProductCondition('ADD', null)}>
                        Create
                      </Button>
                    </div>
                  </Col>
                </Row>
                <Table responsive hover className="ps-table tb-col-5">
                  <thead>
                    <tr>
                      <th>Condition Type</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>params</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.product_condition.length < 1 && (
                      <tr>
                        <td colSpan="5">
                          <div className="ps-empty-data">
                            <div className="empty-content">
                              <MdCreate />
                              <h4>No data to show</h4>
                              <span>Click the 'Create' button to add new product condition</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}

                    {this.state.product_condition &&
                      this.state.product_condition.length > 0 &&
                      this.state.product_condition.map(item => {
                        return (
                          <tr key={item.id}>
                            <td>{item.condition_type}</td>
                            <td>{item.start_date}</td>
                            <td>{item.end_date}</td>
                            <td>{item.params}</td>
                            <td>
                              <div className="ps-action-button">
                                <Button className="theme-button theme-button-secondary" onClick={this.toggleProductCondition('EDIT', item.id)}>
                                  Edit
                                </Button>
                                <Button color="link" className="theme-button theme-button-primary-light" onClick={this.toggleConfirmModal(item.condition_type, item.id, 'ProductCondition')}>
                                  Delete
                                </Button>
                              </div>
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display main">
              <CardBody>
                <Row>
                  <Col>
                    <div className="text-left">
                      <Typography className="h5">Inventory Log</Typography>
                    </div>
                  </Col>
                </Row>
                <Table responsive hover className="ps-table tb-col-6">
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Quantity</th>
                      <th>Pre Quantity</th>
                      <th>Update By</th>
                      <th>Update Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.inventory_log.length < 1 && (
                      <tr>
                        <td colSpan="6">
                          <div className="ps-empty-data">
                            <div className="empty-content">
                              <MdCreate />
                              <h4>No data to show</h4>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}

                    {this.state.inventory_log &&
                      this.state.inventory_log.length > 0 &&
                      this.state.inventory_log.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{item.update_type}</td>
                            <td>{item.qty}</td>
                            <td>{item.pre_qty}</td>
                            <td>{item.update_by}</td>
                            <td>{moment(item.update_dt).tz('Asia/Singapore').format('YYYY-MM-DD HH:mm:ss')}</td>
                          </tr>
                        )
                      })}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display main">
              <CardBody>
                <Row>
                  <Col>
                    <div className="text-left">
                      <Typography className="h5">Order Log</Typography>
                    </div>
                  </Col>
                </Row>
                <MDBDataTableV5 className="ps-order-table th-4" data={data} displayEntries={false} searchTop searchBottom={false} noRecordsFoundLabel="No data to show" fullPagination disableRetreatAfterSorting={true} responsive={true} />
                {/* <Table responsive hover className="ps-table tb-col-4">
                  <thead>
                    <tr>
                      <th>Order ID</th>
                      <th>Quantity</th>
                      <th>Price</th>
                      <th>Update Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.order_log.length < 1 && (
                      <tr>
                        <td colSpan="4">
                          <div className="ps-empty-data">
                            <div className="empty-content">
                              <MdCreate />
                              <h4>No data to show</h4>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}

                    {this.state.order_log &&
                      this.state.order_log.length > 0 &&
                      this.state.order_log.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{item.order_id}</td>
                            <td>{item.qty}</td>
                            <td>{item.price}</td>
                            <td>
                              {moment(item.update_dt)
                                .tz('Asia/Singapore')
                                .format('YYYY-MM-DD HH:mm:ss')}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table> */}
              </CardBody>
            </Card>
          </Col>
        </Row>

        {!this.state.isLoading && (
          <>
            <Modal isOpen={this.state.modal} toggle={this.toggle()} className={this.props.className} centered>
              <PosProductModal history={this.props.history} onToggleModal={this.toggle} closeModal={this.closeModal} match={this.props.match} data={this.state} />
            </Modal>

            <Modal isOpen={this.state.formModal} toggle={this.toggleForm()} className={this.props.className} centered>
              <PosProductForm history={this.props.history} onToggleModal={this.toggleForm} closeModal={this.closeModal} match={this.props.match} data={this.state} />
            </Modal>

            <Modal isOpen={this.state.priceModModal} toggle={this.togglePriceMode()} className={this.props.className} centered>
              <PosPriceModeForm history={this.props.history} onToggleModal={this.togglePriceMode} closeModal={this.closeModal} match={this.props.match} data={this.state} />
            </Modal>

            <Modal isOpen={this.state.conditionModal} toggle={this.toggleProductCondition()} className={this.props.className} centered>
              <PosProductConditionForm history={this.props.history} onToggleModal={this.toggleProductCondition} closeModal={this.closeModal} match={this.props.match} data={this.state} />
            </Modal>
          </>
        )}

        <Modal isOpen={this.state.confirmModal} toggle={this.toggleConfirmModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleConfirmModal()}>Remove Product</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to remove {this.state.selectedData}</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.delete()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.badgeModal} toggle={this.toggleBadgeConfig()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <Form onSubmit={this.ConfigureBadge}>
            <ModalHeader toggle={this.toggleBadgeConfig()}>Configure Badge</ModalHeader>
            <ModalBody>
              <FormGroup check>
                <Label check>
                  <Input type="checkbox" name="edit_show_badge" checked={this.state.edit_show_badge} onChange={this.showbadgeHandler} />
                  Show Badge
                </Label>
              </FormGroup>
              <br />
              <FormGroup>
                <Label>Badge Type</Label>
                <Input className="ps-input-small" type="select" name="edit_badge" value={this.state.edit_badge} onChange={this.changeHandler} required>
                  <option value="On Sale">On Sale</option>
                  <option value="Recommend">Recommend</option>
                  <option value="New">New</option>
                  <option value="Featured">Featured</option>
                </Input>
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Submit
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </Page>
    )
  }
}

export default PosStoreDetailPage
